// DatePickerModal.tsx
import React, { useState } from 'react';
import Modal from 'components/shared/modals/Modal';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import Button from 'components/shared/Button/Button';
import styles from './DatePicker.module.scss';

type DatePickerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (date: Date | null) => void;
  selectedDay: Date | null;
};

const DatePickerModal: React.FC<DatePickerModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  selectedDay,
}) => {
  const [internalDate, setInternalDate] = useState<Date | null>(selectedDay);

  const handleSelect = () => {
    onSelect(internalDate);
    onClose();
  };

  return (
    <Modal
      bottom
      circleCloseBtn
      isOpen={isOpen}
      onClose={onClose}
      className={styles.datePickerModal}
      onClick={e => e.stopPropagation()}
    >
      <div className={styles.modalContent}>
        <div className={styles.header}>Choose date</div>

        <div className={styles.datepickerWrapper}>
          {/* @ts-ignore */}
          <DatePicker
            selected={internalDate}
            onChange={date => setInternalDate(date)}
            inline
            calendarClassName={styles.calendar}  
            dayClassName={() => styles.calendarDay}  
          />
        </div>

        <Button className={styles.footer} onClick={handleSelect} wide darkGreen>
          Apply
        </Button>
      </div>
    </Modal>
  );
};

export default DatePickerModal;